import { ITextChatMessage } from '../model/ITextChatMessage';
import { alanMarkdown } from './alanMarkdown';
import { getLinkIcon } from './helpers/getLinkIcon';

export const LEARN_MORE_LABEL = 'Learn more:';

export function buildLinksContent(msg: ITextChatMessage) {
    let linksBlock = '';
    let linksHtml = '';
    let hasFooterLinks = false;

    if (msg.ctx?.format === 'markdown') {
        const msgContent = alanMarkdown(msg.text || '');
        const tempNode = document.createElement('div');
        tempNode.innerHTML = msgContent;
        hasFooterLinks = !!tempNode.querySelector('.footnotes');
        tempNode.remove();
    }

    const links = msg.links?.filter(link => isValidUrl(link?.href));

    for (let i = 0; i < links?.length; i++) {
        const curLink = links[i];
        const target = getLinkTarget(curLink);
        linksHtml += `<a class="alan-btn__chat-response-link" href="${curLink.href}" target="${target}">
            <span class="alan-btn__chat-response-link-icon-wrapper">${getLinkIcon(curLink)}</span>
            <span class="alan-btn__chat-response-link-title">${curLink.title || curLink.href}</span>
        </a>`;
    }

    if (links?.length) {
        linksBlock = `<div class="alan-btn__chat-response-links-wrapper ${((msg.text || msg.images?.length > 0) && !hasFooterLinks) ? 'with-content-on-top' : ''}">
        ${!hasFooterLinks ? `<span style="margin-right: 10px;display: inline-block;font-weight: 600;">${LEARN_MORE_LABEL} </span>` : ''}
            ${linksHtml}
    </div>`;
    }

    return linksBlock;
}

export function getLinkTarget(link) {
    try {
        return window.location.host === new URL(link.href).host ? '_self' : '_blank';
    } catch (err) {
        return '_blank';
    }
}

function isValidUrl(url) {
    try {
        const parsedUrl = new URL(url);

        const hasValidProtocol = parsedUrl.protocol === "http:" || parsedUrl.protocol === "https:";
        const hasValidHostname = parsedUrl.hostname.length > 0;

        return hasValidProtocol && hasValidHostname;
    } catch (e) {
        return false;
    }
}